// extracted by mini-css-extract-plugin
export default {"error-overlay":"Player_error-overlay__gNmEj"};